import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTelegramWebApp } from '../../../hooks/useTelegramWebApp';
import styles from './MobilePublicHeader.module.css';

/**
 * Mobile Header для публичных страниц (landing) - показывается только на мобильных
 * Содержит: Star AI HUB | Цены | Войти
 */
const MobilePublicHeader = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { haptic } = useTelegramWebApp();
  const headerRef = useRef<HTMLElement>(null);

  const handlePricing = () => {
    haptic.impact('light');
    navigate('/pricing');
  };

  const handleLogin = () => {
    haptic.impact('light');
    navigate('?auth=login');
  };

  return (
    <header ref={headerRef} className={styles.header}>
      <div className={styles.container}>
        {/* Left: Logo text */}
        <div className={styles.logoText}>Star AI HUB</div>
        
        {/* Right: Pricing + Login */}
        <div className={styles.right}>
          <button className={styles.pricingButton} onClick={handlePricing}>
            {t('nav.pricing')}
          </button>
          <button className={styles.loginButton} onClick={handleLogin}>
            {t('nav.signIn')}
          </button>
        </div>
      </div>
    </header>
  );
};

export default MobilePublicHeader;
